// routing
import Routes from "routes";

// project imports
import NavigationScroll from "layout/NavigationScroll";
import ThemeCustomization from "themes";
import Locales from "ui-component/Locales";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Helmet } from "react-helmet";

// auth provider
import { FirebaseProvider as AuthProvider } from "contexts/FirebaseContext";
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

function App() {
  // Get environment from variable
  const isProd = process.env.REACT_APP_ENV === "production";

  return (
    <>
      <Helmet>
        {isProd ? (
          <meta name="robots" content="index, follow" />
        ) : (
          <meta name="robots" content="noindex, nofollow" />
        )}
      </Helmet>

      <ThemeCustomization>
        {/* RTL layout */}
        <Locales>
          <NavigationScroll>
            <AuthProvider>
              <>
                <Routes />
                {/* <Snackbar /> */}
              </>
            </AuthProvider>
          </NavigationScroll>
        </Locales>
      </ThemeCustomization>
    </>
  );
}

export default App;
